// Module
var code = "<span system-dictionary=\"PriceComingSoon\"></span>";
// Exports
module.exports = code;